export default __webpack_public_path__ + "static/media/mobileLayout.c2dca47f.png";